import { createSlice } from "@reduxjs/toolkit";

export const dailyExpenseSlice = createSlice({
  name: "dailyExpense",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
   expenseList: [],
    model: false,
    error_msg: null,
    rowdata: {},
    expenseParams: {
      no_of_pages: 0,
      listCount: 0,
      page_size: 10,
      page: 1,
      search: "",
    },
  },
  reducers: {
    getExpensesList: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    expensesListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.expenseParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        expenseList: action.payload.response.results,
        loading: false,
        expenseParams: {
          ...state.expenseParams,
          no_of_pages: noofpages,
        },
      };
    },
    expensesAdd: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    expensesAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    expensesEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },
    expensesSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },
    expensesDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetExpenseParams: (state, action) => {
      return {
        ...state,
        expenseParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getExpensesList,
  expensesListSuccessful,
  expensesAdd,
  expensesAddSuccessful,
  expensesEdit,
  expenses,
  expensesDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetExpenseParams
} = dailyExpenseSlice.actions;

export default dailyExpenseSlice.reducer;
